import React, { Component } from 'react';

import img1 from '../assets/images/about-1.jpg';

class SectionAbout extends Component {
  constructor(props) {
    super(props);
    this.state = {  }
  }
  
  render() { 
    return (
      <section className="ftco-about ftco-counter ftco-no-pb img ftco-section" id="about-section">
        <div className="container">
          <div className="row d-flex">
            <div className="col-md-6 col-lg-5 d-flex">
              <div className="img-about img d-flex align-items-stretch">
                <div className="overlay"></div>
                <div className="img d-flex align-self-stretch align-items-center" style={{backgroundImage: `url(${img1})`}}>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-7 pl-lg-5 pt-5">
              <div className="row justify-content-start pb-3">
                <div className="col-md-12 heading-section">
                  <span className="subheading">Welcome</span>
                  <h2 className="mb-4" style={{fontSize: '34px', textTransform: 'capitalize'}}>About Samawa</h2>
                  <p>Kami adalah jasa pembuatan website dengan bekal pengalaman coding kami dalam membuat website yang modern.</p>
                  <p>Website buatan kami berbeda dengan jasa pembuatan website yang lain pada umumnya yang memakai cms wordpress atau sejenisnya. Disini kami memakai teknologi bahasa pemrograman web yang biasa dipakai oleh para programmer web profesional.</p>
                </div>
              </div>
              <div className="counter-wrap d-flex mt-md-3">
                <div className="text p-4 pr-5 bg-primary">
                  <p className="mb-0">
                    <span className="number">Welcome To Samawa</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
 
export default SectionAbout;